import { React, useState, useEffect } from "react";

const PopUpCasinowarResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let casinoWarCards = [];
    let casinoWarResults = [];
    let casinoWarPlayers = [];

    if (marketType == 21) {

        casinoWarCards =
            typeof resultData?.cards_desc === "string"
                ? resultData.cards_desc.split(",")
                : [];

        casinoWarResults =
            typeof resultData?.result_desc === "string"
                ? resultData.result_desc.split(",")
                : [];

        casinoWarPlayers = [
            resultData?.cat_rnr1,
            resultData?.cat_rnr2,
            resultData?.cat_rnr3,
            resultData?.cat_rnr4,
            resultData?.cat_rnr5,
            resultData?.cat_rnr6,
        ].filter(Boolean);

    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="casino-war" style={{ display: marketType == 21 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item" style={{ textAlign: "center" }}>
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>Dealer Cards</span>
                                        </b>

                                        <div className="player-card" style={{ display: "flex", justifyContent: "center" }}>
                                            <div className="BFBCardHandViewDealerab" style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                                <div className="BFBCardFanViewab" style={{ display: "flex", justifyContent: "center", padding: "3px" }}>
                                                    {casinoWarCards[0] && (
                                                        <div className="RSMImageView2ab">
                                                            <img src={`/assets/images/cards/${casinoWarCards[0]}.svg`} style={{ width: "100%", maxWidth: "45px", height: "auto" }} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {casinoWarPlayers.map((player, index) => (
                                        <div className="player-item" key={index}>
                                            <b>
                                                <span className="name" style={{ color: "#000" }}>
                                                    {player}
                                                </span>
                                            </b>
                                            <div className="player-card">
                                                <div className="BFBCardHandViewDealerab">
                                                    <div
                                                        className="BFBCardFanViewab"
                                                        style={{
                                                            justifyContent: "flex-start",
                                                            padding: "2px"
                                                        }}
                                                    >
                                                        {casinoWarCards[index + 1] && (
                                                            <div className="RSMImageView2ab">
                                                                <img
                                                                    src={`/assets/images/cards/${casinoWarCards[index + 1]}.svg`}
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: "45px",
                                                                        height: "auto"
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div style={{ marginTop: "10px" }}>
                                        {casinoWarPlayers.map((player, index) => {
                                            const winner =
                                                Number(casinoWarResults[index]) !== 0;
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                        marginBottom: "18px"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "22px",
                                                            fontWeight: "700"
                                                        }}
                                                    >
                                                        {player}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpCasinowarResults;

